import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { SEOMeta } from '@/components/SEOMeta';
import { PageBreadcrumb } from '@/components/PageBreadcrumb';

const BREADCRUMBS = [{ label: 'Отказ от отговорност', href: '/disclaimer' }];

export default function DisclaimerPage() {
  return (
    <>
      <SEOMeta
        title="Отказ от отговорност"
        description="Медицински отказ на portion.bg. Платформата е с образователна цел и не замества медицинска консултация. Не е подходяща за лица с диабет или метаболитни нарушения."
        keywords="portion.bg медицински отказ, хранителен план отказ от отговорност"
        canonical="/disclaimer"
        breadcrumbs={BREADCRUMBS}
      />
      <PageBreadcrumb items={BREADCRUMBS} />
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.35 }}>
        <div className="text-center mb-10">
          <div className="w-14 h-14 bg-amber-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <AlertTriangle className="w-7 h-7 text-amber-500" />
          </div>
          <Badge className="bg-amber-50 text-amber-700 border-amber-200 border mb-4">Медицински отказ</Badge>
          <h1 className="text-3xl font-semibold text-gray-900 dark:text-gray-100 mb-3">Отказ от отговорност</h1>
        </div>
        <div className="bg-amber-50 border border-amber-200 rounded-xl p-6 sm:p-8 space-y-5 mb-6">
          {[
            { title: 'Информацията е с образователна цел', content: 'Тази платформа предоставя информация единствено за образователни цели. Тя не замества медицинска консултация, диагноза или лечение.' },
            { title: 'Не е подходящо за хора', content: 'Тази платформа не е подходяща за лица с диабет, инсулинова резистентност, Хашимото, сърдечно-съдови заболявания, бременност или други метаболитни нарушения.' },
            { title: 'Консултирайте лекар', content: 'Преди започване на нов хранителен режим, консултирайте се с лекар или диетолог, особено ако имате хронични заболявания.' },
          ].map(s => (
            <div key={s.title}>
              <h2 className="text-base font-semibold text-amber-900 mb-2">{s.title}</h2>
              <p className="text-sm text-amber-800 leading-relaxed">{s.content}</p>
            </div>
          ))}
        </div>
      </motion.div>
    </div>
    </>
  );
}
